const borderColor = "rgba(1,67,57,0.1)";

const styles = {
  list: {
    border: `1px solid ${borderColor}`,
    borderRadius: 1.5,
    overflow: "hidden",
    backgroundColor: "background.paper",
  },
  row: {
    display: "flex",
    alignItems: "center",
    px: { xs: 1, md: 1.5 },
    py: 1,
    gap: { xs: 0.75, md: 1.5 },
    borderBottom: `1px solid ${borderColor}`,
    "&:last-of-type": {
      borderBottom: "none",
    },
  },
  brandHeader: {
    display: "flex",
    alignItems: "center",
    gap: { xs: 0, sm: 1.5 },
    minWidth: 0,
    flexShrink: 0,
  },
  brandAvatar: {
    display: { xs: "none", sm: "flex" },
  },
  brandInfo: {
    display: "flex",
    flexDirection: "column",
    width: { xs: 90, md: 140 },
    flexShrink: 0,
    minWidth: 0,
  },
  brandName: {
    fontWeight: 600,
    fontSize: 13,
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  brandHandle: {
    fontSize: 11,
    color: "rgba(1,67,57,0.6)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  divider: {
    width: "1px",
    backgroundColor: borderColor,
    alignSelf: "stretch",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    ml: "auto",
    flexShrink: 0,
  },
  contactInfo: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  expanded: {
    backgroundColor: "#fafaf6",
  },
  contactList: {
    p: 1.5,
    backgroundColor: "#fafaf6",
    borderTop: `1px solid ${borderColor}`,
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    py: 0.75,
    cursor: "pointer",
    borderRadius: 1,
    px: 1,
    "&:hover": {
      backgroundColor: "rgba(1,67,57,0.04)",
    },
  },
  contactItemSelected: {
    backgroundColor: "#e7f4ee",
    "&:hover": {
      backgroundColor: "#e7f4ee",
    },
  },
  addOwnContact: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    py: 1,
    px: 1,
    color: "primary.main",
    cursor: "pointer",
    borderTop: `1px dashed ${borderColor}`,
    "&:hover": {
      backgroundColor: "rgba(1,67,57,0.04)",
    },
  },
  paginationBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: { xs: "column", md: "row" },
    gap: 1,
    mt: 2,
  },
};

export default styles;
